import { render, staticRenderFns } from "./ViewDetailTopPicList.vue?vue&type=template&id=0edcd966"
import script from "./ViewDetailTopPicList.vue?vue&type=script&lang=js"
export * from "./ViewDetailTopPicList.vue?vue&type=script&lang=js"
import style0 from "./ViewDetailTopPicList.vue?vue&type=style&index=0&id=0edcd966&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports